import TableInfo from "./TableInfo/TableInfo";
import classes from "./Table.module.scss";
import { useTranslation } from "react-i18next";

const Table = ({
  id,
  size,
  tableNum,
  status,
  shape,
  isSelected,
  onClicked,
}) => {
  const { t } = useTranslation();
  let tableBoxStyleClasses = classes.Table;
  let tableStyleClasses = null;
  let statusStyleClasses = classes.StatusBar;

  switch (shape) {
    case "round":
      tableStyleClasses = classes.RoundTable;
      break;

    default:
      tableStyleClasses = classes.SquareTable;
      break;
  }

  switch (status) {
    case "Reserved":
      statusStyleClasses = [statusStyleClasses, classes.Reserved].join(" ");
      break;

    case "Available":
      statusStyleClasses = [statusStyleClasses, classes.Available].join(" ");
      break;

    case "Occupied":
      statusStyleClasses = [statusStyleClasses, classes.Occupied].join(" ");
      break;

    case "Disabled":
      statusStyleClasses = [statusStyleClasses, classes.Disabled].join(" ");
      break;

    default:
      statusStyleClasses = [statusStyleClasses, classes.Available].join(" ");
      break;
  }

  if (isSelected) {
    tableBoxStyleClasses = [tableBoxStyleClasses, classes.Selected].join(" ");
  }

  return (
    <div
      className={tableBoxStyleClasses}
      onClick={() => onClicked(id, tableNum)}
    >
      <TableInfo leftText={t("RESERVATION_ID") + ":"} rightText={id} />
      <TableInfo
        leftText={t("PARTY_SIZE") + ":"}
        rightText={`${size} persons`}
      />
      <TableInfo leftText={t("STATUS") + ":"} rightText={status} />
      <div className={classes.TableIcon}>
        <div className={classes.Seat}></div>
        <div className={classes.Seat}></div>
        <div className={classes.Seat}></div>
        <div className={classes.Seat}></div>
        <div className={tableStyleClasses}>{tableNum}</div>
      </div>
      <div className={statusStyleClasses}></div>
    </div>
  );
};

export default Table;
